import { FormattedMessage } from 'react-intl'

import { Typography } from '@gto/ui/typography'

export const DealsPageHeader = ({ location }: { location?: string }) => {
  const countryName = location ?? ''

  return (
    <div className="flex flex-col gap-8 p-16 md:gap-6 md:p-8">
      <div className="text-center">
        <Typography
          gutterBottom
          color="primary"
          component="h1"
          variant="h3"
        >
          <FormattedMessage
            id="deals.title"
            values={{
              country: countryName,
              wrapper: (chunks) => {
                if (!countryName) {
                  return null
                }

                return (
                  <Typography
                    className="font-semibold [font-size:inherit]"
                    component="span"
                  >
                    {chunks}
                  </Typography>
                )
              },
            }}
          />
        </Typography>
        <Typography
          className="font-semibold"
          color="text.secondary"
          component="h2"
          variant="h6"
        >
          <FormattedMessage id="deals.description" />
        </Typography>
      </div>
    </div>
  )
}
